import React from 'react';
import { translate } from 'react-i18next';
import { Link } from 'react-router-dom';

const DropdownSubcompanies = ({ company, subcompany, subcompanies, t }) => (
  <li className="dropdown inverse">
    <a>
      {!subcompany ? t('actions.select_one') : subcompany.shortname}
      <i className="fa fa-angle-down" />
    </a>
    <ul className="dropdown-menu">
      {subcompanies.map((s) => (
        <li key={s.id}>
          <Link to={`/companies/${company.id}/subcompanies/${s.id}/dashboard`}>
            <span className="badge badge-default">
              <i className="fa fa-building" />
            </span>
            {s.shortname}
          </Link>
        </li>
      ))}

      <li>
        <Link className="inverse" to={`/companies/${company.id}/subcompanies/add`}>
          <span className="badge badge-success">
            <i className="fa fa-plus" />
          </span>
          {t('menu.subcompanies_add')}
        </Link>
      </li>
      <li>
        <Link className="inverse" to={`/companies/${company.id}`}>
          <span className="badge badge-success">
            <i className="fa fa-cog" />
          </span>
          {t('menu.subcompanies')}
        </Link>
      </li>
    </ul>
  </li>
);

export default translate()(DropdownSubcompanies);



// WEBPACK FOOTER //
// src/modules/secured/components/layout/nav/DropdownSubcompanies.js